<template>
<div id="app">
  <b-modal id="editModal" v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
      header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant >
    <template slot="modal-header" > 
        <div  style="margin: 0 auto;">
        <small class="PopUpTitle w-100 text-center">{{Poptitle}}</small>
      </div> 
    </template>
     <TaxStandardAddEdit v-if="showEditModal==true" :UserData="UserData" :mode="mode" @taxUpdated="closeModal"></TaxStandardAddEdit>
      <div slot="modal-footer" class="w-100"> </div>
  </b-modal> 

<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fas fa-money-check-alt"></i><b>Manage Tax Standard:</b>
</template> 
</Subtitle> 
<Card>
  <CardBody>
    <p>Manage Tax is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
  </CardBody>
</Card> 
<v-client-table :columns="columns" :data="tableData" :options="options">
  <template slot="status" slot-scope="props">
    <span>{{ props.row.status.toUpperCase() }}</span>
  </template> 
  <span v-on:click="EditTaxStandardPopup(props.row)" slot="edit" slot-scope="props" class="pointer" ><i class="far fa-edit"></i></span> 
  <div v-if="showEdit" slot="beforeFilter"  class="VueTables_Adduser">
    <label for="VueTables_Adduser" class="VueTables_Adduser"> Add New Tax Standard: </label>
    <button type="button" v-on:click="AddTaxStandardPopup" class="btn btn-primary form-control ">ADD Tax Standard</button>
  </div>
</v-client-table>     
</div>
</template>
<script>

import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue'; 
import TaxStandardAddEdit from '@/components/DPEBB/Administrator/TaxStandardAddEdit.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Subtitle from '@/Common/Default/SubTitle.vue'; 
export default {
  props:{
        AllowEdit:'',
    },
  
  components: {
        Modal:Modal,
        TaxStandardAddEdit,
        Card,
        CardBody,
        TileNote,
        Subtitle
        //AddTaxstd:AddTaxstd
    },
    
    data: function () {
    return {
        AppServiceID :6,
        //TaxstdData:'',
        UserData:'',
        Poptitle:'Add Tax Standard',
        isModalVisible: true,
        showEdit:true,
        showEditModal:false,
        mode:'',
        PopUpVar:PopUpVariant, 
        // columns: ['status','edit','taxtype','percentage','effectivedate','expirydate'],
        columns: ['status','edit','taxtype','percentage','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
        tableData: [],//getData(),
        options: {
        sortable: ['status','taxtype','percentage','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search Tax Standard Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          },
          responseAdapter({data}) {
            // const formatData = data.map(o => {
            //     const dataCopy = JSON.parse(JSON.stringify(o))
            //     dataCopy.expirydate = moment(o.expirydate).format('MMMM Do YYYY')
            //     return dataCopy
            //   })
              return {
                data: formatData,
                count: data.length
              };
              // return {
              //   data,
              //   count: data.length
              // }
            },
         // skin:'table table-hover',
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['expirydate','effectivedate'],
          toMomentFormat: 'YYYY-MM-DD',
          //templates: {edit: 'edit'},
          templates: {
            expirydate(h, row) {         
              return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            effectivedate(h, row) {         
              return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            createddate(h, row) {         
              return moment(row.createddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            }, 
            modifieddate(h, row) {         
              return moment(row.modifieddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },   
            percentage(h,row){
              return parseFloat((row.percentage * 100).toFixed(3));
            },
            //status(h, row) {
              // if(row.status.toUpperCase() == 'ACTIVE')
              // {
              //    return <span style="color:green" v-b-tooltip title="Active"><i class="fas fa-check-circle" ></i></span>
              // }
              // else if(row.status.toUpperCase() == 'INACTIVE')             
              // {
              //    return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>  
              // }
              // else{
              //    return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle-right"></i></span>  
              // }
           // },
            // created_at(h, row) {
            //   Moment.locale('es');
            //   return moment(row.expirydate).format('YYYY/MM/DD'); //(moment.HTML5_FMT.DATETIME_LOCAL);   //row.created_at | moment("DD-MM-YYYY");
            // },
            // delete(h, row) {
            //     return <button on-click={ () => this.showItem(row) } class="btn btn-primary btn-sm"><i class="glyphicon glyphicon-edit"></i></button>
            // },
          },
          headings: {
            edit: 'Edit',
            taxtype: 'Tax Type',
            percentage: 'Percentage',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            createdby: 'Created By',
            createddate: 'Created Date',
            lastmodifiedby: 'Last Modified By',
            modifieddate: 'Last Modified Date'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          //filterable: ['username', 'fullname'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
          }      
      }
     
    },
    computed:{  
    },
    created: function () {
        this.showEdit = this.AllowEdit;
        this.loadTable();  
    },
    mounted: function(){
         if (!this.showEdit) {
          this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
     }},

     methods: {
        loadTable() {
        var vm = this;
          axios.get('/SaskHealthApi/Codes/GetTaxStandard?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
          .then(function (response) {
                vm.tableData=response.data;
              })
              .catch(function (er) {
                  console.log(er)
              });  

        },
          AddTaxStandardPopup(Rowdata){
            this.mode='Add';
            this.Poptitle="Add Tax Standard"
            this.UserData='';            
            this.showEditModal=true;
        },
         EditTaxStandardPopup(Rowdata){     
            this.mode='Edit';
            this.Poptitle="Edit Tax Standard" 
            console.log('dbkey = ' + Rowdata.dbkey)      
            this.UserData= Rowdata;            
            this.showEditModal=true;              
        },
        
        closeModal() {
        this.isModalVisible = false;
        this.loadTable();
      }
    },
    
}
</Script>
<style>

</style>